import { useAuth } from '@sp/data/auth';
import { SpinnerPage } from '@sp/ui/elements';
import { useRedirectAfterLogin } from '@sp/util/router';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function ContinueGoogleOauth() {
  const { isLoggedIn, continueLoginWithGoogle } = useAuth();
  const { redirectUrl, setRedirect } = useRedirectAfterLogin();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(redirectUrl);
      setRedirect('/');
    }
  });

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const code = search.get('code');

    if (code) {
      window.history.replaceState({}, document.title, window.location.pathname);
      continueLoginWithGoogle({ code });
    }
  }, [continueLoginWithGoogle]);

  return <SpinnerPage />;
}
